export default __webpack_public_path__ + "static/media/teamBg3.c68f33fd.png";